import { render, staticRenderFns } from "./DebugItem.vue?vue&type=template&id=f2fe2abe"
import script from "./DebugItem.vue?vue&type=script&lang=js"
export * from "./DebugItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports